// extracted by mini-css-extract-plugin
export default {"items":"inline-list_items__4OXZZ","item":"inline-list_item__2ay-H"};